export default __webpack_public_path__ + "static/media/coming-soon-dark.20458d3f.svg";